import { TAxiosResponse } from '../baseApiTypes';
import { api } from '../index';
import { TSubscriptionInfoResponse, TSubscriptionOldInfoResponse, TSubscriptionOldPlansResponse, TSubscriptionPlansResponse } from './types';

export const getOldSubscription = (): TAxiosResponse<TSubscriptionOldInfoResponse> =>
  api.get('/paypal/subscription/show');

export const getSubscription = (userId: any): TAxiosResponse<TSubscriptionInfoResponse> =>
  api.get(`/stripe/getuserplan/${userId}`);

export const cancelSubscription = (subName: any): TAxiosResponse<any> =>
  api.post('stripe/subscription/cancel', {subName});

export const resumeSubscription = (subName: any): TAxiosResponse<any> =>
  api.post('stripe/subscription/resume', {subName});

export const cancelOldSubscription = (): TAxiosResponse<any> =>
  api.get('paypal/subscription/cancel');

export const setSubscriptionAsPending = (): TAxiosResponse<any> =>
  api.get('/user/status-update');

export const getSubscriptionPlans = (): TAxiosResponse<TSubscriptionPlansResponse> =>
  api.get('/stripe/getallplans');

export const getOldSubscriptionPlans =
  (): TAxiosResponse<TSubscriptionOldPlansResponse> =>
    api.get('/subscription-plans');

export const paymentCall = (items: any): TAxiosResponse<any> =>
  api.post('/stripe/plan/process', items);


export const SubscriptionsApi = {
  getSubscription,
  cancelSubscription,
  resumeSubscription,
  setSubscriptionAsPending,
  getSubscriptionPlans,
  paymentCall,
  getOldSubscription,
  getOldSubscriptionPlans,
  cancelOldSubscription
};
